module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/coupon/coupon.component.scss
// module id = ./src/app/admin/coupon/coupon.component.scss
// module chunks = main